module.exports = __webpack_public_path__ + "img/osn.a896aa21.png";